import {Router} from '@angular/router';
import {Component, Inject} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {StorageService} from '../service/storage.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';

@Component({
    selector: 'app-salarycheck',
    templateUrl: './salarycheck.component.html',
    styleUrls: ['./salarycheck.component.css'],
    providers: [ApiServiceService]
})
export class SalarycheckComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ref: ApiServiceService, private router: Router,
                private storageService: StorageService, public dialog: MatDialog, public dialogRef: MatDialogRef<SalarycheckComponent>,
                public analyticsTracker: AnalyticsTracker) {
    }

    logout() {
        this.storageService.clear();
        this.storageService.clearSessionStorage();
        this.router.navigate(['/']);
    }

    closeModal() {
        this.dialog.closeAll();
    }
}
